import React from "react";
import { Link } from "react-router-dom";
import ActivityFooter from "../common/ActivityFooter";

const BurndownChartPage2 = ({ color, onBack, onContinue }) => {
  return (
    <div>
      <div className="content-area flex-grow">
        <div className="bg-gallery px-15 sm:px-50 lg:px-15 py-11">
          <div className="lg:max-w-520 mx-auto">
            <h1 className="uppercase font-bold text-gray-800 my-0 text-md">
              CREATE AN BURNDOWN CHART
            </h1>
          </div>
        </div>
        <div className="inner-content px-15 sm:px-50 lg:px-15 pt-19 mx-auto pb-25 lg:pb-8 text-gray-800">
          <p>
            In column A, enter the tasks your team generated when you created
            the{" "}
            <a
              className="term-link text-orange-100 hover:text-gray-800"
              href="/"
              data-term="WORK BREAKDOWN STRUCTURE (WBS)"
            >
              Work Breakdown Structure (WBS)
            </a>
            .
          </p>
        </div>
        <div className="row flex justify-center sm:-mx-35">
          <Link
            to="/app/activity/create-wbs"
            className="btn-lg flex px-10 pt-11 pb-9 sm:pt-6 sm:pb-4 uppercase bg-orange-100 text-white hover:bg-gray-900 hover:text-white font-secondary font-bold mx-5 mb-5"
          >
            <strong className="flex items-center font-bold">
              SHOW ME HOW TO CREATE A WBS{" "}
            </strong>
          </Link>
          <a
            href="templates/template-demo.pdf"
            target="_blank"
            className="btn-lg btn-download flex p-10 sm:py-5 uppercase bg-orange-100 text-white hover:bg-gray-900 hover:text-white font-secondary font-bold mx-5 mb-5"
          >
            <strong className="flex items-center font-bold">
              <span className="flex-grow">DOWNLOAD TEMPLATE </span>
              <span className="icon-download ml-5"></span>
            </strong>
          </a>
        </div>
        <div className="text-center pt-33">
          <img
            className="inline-block align-top"
            src="images/img87.jpg"
            alt=" description"
            width="375"
            height="220"
          />
        </div>
      </div>

      <ActivityFooter color={color} onBack={onBack} onContinue={onContinue} />
    </div>
  );
};

export default BurndownChartPage2;
